import { GLOBAL_CONSTANTS } from '../../../../constants.js';
import { encodeAbiParameters } from 'viem';
export const getValueLimitPolicy = (params) => {
    return {
        policy: GLOBAL_CONSTANTS.VALUE_LIMIT_POLICY_ADDRESS,
        address: GLOBAL_CONSTANTS.VALUE_LIMIT_POLICY_ADDRESS,
        initData: encodeAbiParameters([{ type: 'uint256' }], [params.limit]),
    };
};
//# sourceMappingURL=installation.js.map